import { useCallback } from 'react';

import { DailyGoalTypeNames } from 'bundles/daily-goals/constants';
import { useUpdateDailyGoalsApolloCache } from 'bundles/daily-goals/hooks/useUpdateDailyGoalsApolloCache';
import { useDailyGoalsData } from 'bundles/daily-goals/providers/DailyGoalsDataProvider';
import { isAddCareerGoalGoal, isGoalCompleted } from 'bundles/daily-goals/utils/dailyGoalsUtils';

/**
 * This hook returns a function that marks the add career goal as complete.
 */
export const useMarkAddCareerGoalAsComplete = () => {
  const { markGoalComplete } = useUpdateDailyGoalsApolloCache();
  const { activeCourseId, pushToastId, dailyGoals } = useDailyGoalsData();

  const markAddCareerGoalAsComplete = useCallback<() => void>(() => {
    if (!activeCourseId) {
      return;
    }

    const addCareerGoal = dailyGoals?.find(isAddCareerGoalGoal);

    if (!addCareerGoal || isGoalCompleted(addCareerGoal)) {
      return;
    }

    markGoalComplete(activeCourseId, addCareerGoal.goalId);
    pushToastId(DailyGoalTypeNames.AddCareerGoal);
  }, [activeCourseId, markGoalComplete, pushToastId, dailyGoals]);

  return { markAddCareerGoalAsComplete };
};
